import dynamic from "next/dynamic";

/**
 * SSR-safe entry point for <RiveAnimation>. Import THIS in pages/components that
 * server-render — Rive is canvas + WASM and must not run during SSR/SSG.
 *
 *   import RiveAnimation from "@/components/ui/rive-animation.dynamic";
 *
 * The heavy `@rive-app/react-webgl2` import is pulled in only on the client,
 * matching the existing `dynamic(..., { ssr: false })` precedent in the app.
 */
const RiveAnimation = dynamic(
  () => import("./rive-animation").then((m) => m.RiveAnimation),
  { ssr: false }
);

export default RiveAnimation;
export type { IRiveAnimationProps } from "./rive-animation";
